// Only what Bootstrap cannot do: no `min-height: 0`/`min-w-0` utility ships (styling guide §1).
// `min-width: 0` is the second shrink floor — this column is a flex item of the outer
// `d-flex flex-column` wrapper, so it needs the same shrink floor as MessageContent.tsx's
// `.flexFill` to stop a long unbroken message body from stretching the whole scroll region.
.threadMessages {
  min-height: 0;
  min-width: 0;
}
